function AjaxError (rep, msg, file, line) {
  const instance = new Error(msg, file, line)
  instance.name = 'AjaxError'
  instance.rep = rep
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this))
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, AjaxError)
  }
  return instance
}

AjaxError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
})

if (Object.setPrototypeOf) {
  Object.setPrototypeOf(AjaxError, Error)
} else {
  // eslint-disable-next-line no-proto
  AjaxError.__proto__ = Error
}

function numbersToString (data) {
  for (const key in data) {
    const element = data[key]
    if (typeof element === 'number') data[key] = element.toString()
    else if (typeof element === 'object') data[key] = numbersToString(element)
  }
  return data
}

function formatParams (params){
  return "?" + Object
        .keys(params)
        .map(function(key){
          return key+"="+encodeURIComponent(params[key])
        })
        .join("&")
}

const SESSIONIDHEADER = 'tgWebSessionId'
let sessionId = ''

function promiseUrlFetch (method, url, data, options) {
  return new Promise(function (resolve, reject) {
    try {
      var xhr = new XMLHttpRequest()
      xhr.onloadend = function () {
        if (this.status === 200) {
          if (options.getSessionId) {
            let id = xhr.getResponseHeader(SESSIONIDHEADER) || ''
            if (id) sessionId = id
          }
          resolve({
            status: this.status || 500,
            statusText: this.statusText || '',
            contentType: xhr.getResponseHeader('content-type'),
            response: this.response || '',
            responseText: this.responseText || '',
            responseURL: this.responseURL || '',
          })
        } else {
          // reject(new AjaxError({
          //   status: this.status || 500,
          //   statusText: this.statusText || '',
          //   response: this.response || ''
          // }, this.statusText || 'Error'))
          reject({
            status: this.status || 500,
            statusText: this.statusText || '',
            response: this.response || '',
            responseText: this.responseText || '',
            responseURL: this.responseURL || '',
          })
        }
      }
      //GET or HEAD requests cannot have a body
      //when using get the parameters have to be sent as query parameters
      if (method === 'GET') url += formatParams(data || [])

      xhr.open(method, url, true)
      xhr.withCredentials = true
      options = options || {}
      if (options.type) xhr.responseType = options.type
      if (options.headers) {
        for (var hdr in options.headers) {
          xhr.setRequestHeader(hdr, options.headers[hdr])
        }
      }
      data = data || null
      if (method === 'POST') {
        if (data && typeof data === 'object') {
          data = numbersToString(data)
          data = JSON.stringify(data)
        }
      }
      xhr.send(data)
    } catch (ex) {
      reject(ex)
    }
  })
}

export default {
  get (url, data, getSessionId) {
    const options = {
      headers: {
        'content-type': 'application/json'
      },
      getSessionId: getSessionId
    }
    if (!getSessionId && sessionId) options.headers[SESSIONIDHEADER] = sessionId
    return promiseUrlFetch('GET', url, data, options)
  },
  post (url, data) {
    const options = {
      headers: {
        'content-type': 'application/json'
      }
    }
    if (sessionId) options.headers[SESSIONIDHEADER] = sessionId
    return promiseUrlFetch('POST', url, data, options)
  }
}

export { AjaxError }
